/* Madame Passion — PDP variant picker, gallery sync, sticky add-to-cart. */
(function () {
  "use strict";

  var root = document.querySelector("[data-product-form]");
  if (!root) return;

  var variants = JSON.parse(root.querySelector("[data-product-json]").textContent);
  var selected = {};

  variants.forEach(function (variant) {
    variant.options.forEach(function (value, index) {
      if (!(index in selected)) {
        /* seed from the option group's currently pressed pill, if any */
        var group = root.querySelector('[data-option-selector][data-option-index="' + index + '"]');
        if (group) {
          var pressed = group.querySelector('[aria-pressed="true"]');
          if (pressed) selected[index] = pressed.dataset.optionValue;
        }
      }
    });
  });

  function findMatchingVariant() {
    return variants.find(function (variant) {
      return Object.keys(selected).every(function (index) {
        return variant.options[index] === selected[index];
      });
    });
  }

  function updateUI(variant) {
    var addBtns = document.querySelectorAll("[data-add-to-cart]");
    var checkoutBtns = root.querySelectorAll("[data-buy-now], [data-cod-checkout]");
    var priceWrapper = root.querySelector("[data-price-wrapper]");
    var availabilityText = root.querySelector("[data-availability-text]");
    var skuText = root.querySelector("[data-sku-text]");

    if (!variant) {
      addBtns.forEach(function (btn) {
        btn.disabled = true;
        var label = btn.querySelector("[data-add-to-cart-label]");
        if (label) label.textContent = window.theme.strings.unavailable || "Unavailable";
      });
      checkoutBtns.forEach(function (btn) {
        btn.disabled = true;
      });
      return;
    }

    checkoutBtns.forEach(function (btn) {
      btn.dataset.variantId = variant.id;
      btn.disabled = !variant.available;
    });

    addBtns.forEach(function (btn) {
      btn.dataset.variantId = variant.id;
      btn.disabled = !variant.available;
      var label = btn.querySelector("[data-add-to-cart-label]");
      var text = variant.available ? window.theme.strings.addToCart : window.theme.strings.soldOut;
      if (label) {
        label.textContent = text;
      } else {
        btn.textContent = text;
      }
    });

    if (priceWrapper) {
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      priceWrapper.innerHTML = onSale
        ? '<span class="price"><span class="price__sale">' +
          window.theme.priceHTML(variant.price) +
          '</span><span class="price__compare">' +
          window.theme.priceHTML(variant.compare_at_price) +
          "</span></span>"
        : '<span class="price"><span class="price__regular">' + window.theme.priceHTML(variant.price) + "</span></span>";
    }

    if (skuText) {
      if (variant.sku) {
        skuText.textContent = skuText.textContent.split(":")[0] + ": " + variant.sku;
        skuText.hidden = false;
      } else {
        skuText.hidden = true;
      }
    }

    if (availabilityText) {
      availabilityText.textContent = variant.available ? window.theme.strings.inStock : window.theme.strings.soldOut;
      availabilityText.style.color = variant.available ? "" : "var(--color-error)";
    }

    if (variant.featured_image) {
      var slide = root.querySelector('[data-media-id="' + variant.featured_image.id + '"]');
      if (slide) slide.scrollIntoView({ block: "nearest", inline: "start", behavior: "smooth" });
    }

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      window.history.replaceState({}, "", url);
    }
  }

  /* Delegated on document, not root: the sticky add-to-cart bar renders
     outside <product-form> in the DOM, so a root-scoped listener never sees
     clicks on it. The handlers below already look up state via root.querySelector
     rather than relying on `this`/currentTarget, so this is safe. */
  document.addEventListener("click", function (e) {
    var pill = e.target.closest("[data-option-value]");
    if (pill) {
      var group = pill.closest("[data-option-selector]");
      if (!group) return;
      group.querySelectorAll("[data-option-value]").forEach(function (btn) {
        btn.setAttribute("aria-pressed", "false");
      });
      pill.setAttribute("aria-pressed", "true");
      selected[group.dataset.optionIndex] = pill.dataset.optionValue;
      updateUI(findMatchingVariant());
      return;
    }

    if (e.target.closest("[data-pdp-qty-increase]")) {
      var incInput = root.querySelector("[data-pdp-qty-input]");
      incInput.value = Math.max(1, parseInt(incInput.value, 10) + 1);
    }
    if (e.target.closest("[data-pdp-qty-decrease]")) {
      var decInput = root.querySelector("[data-pdp-qty-input]");
      decInput.value = Math.max(1, parseInt(decInput.value, 10) - 1);
    }

    var addBtn = e.target.closest("[data-add-to-cart]");
    if (addBtn && !addBtn.disabled) {
      var qtyInput = root.querySelector("[data-pdp-qty-input]");
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      addBtn.disabled = true;
      window.theme.cart
        .add(addBtn.dataset.variantId, qty, discreetPackagingProperties())
        .catch(function () {})
        .finally(function () {
          addBtn.disabled = false;
        });
    }

    /* Buy Now: add the current variant then send the shopper straight to checkout. */
    var buyNowBtn = e.target.closest("[data-buy-now]");
    if (buyNowBtn && !buyNowBtn.disabled) {
      goToCheckout(buyNowBtn);
    }

    /* Cash-on-delivery button: same add-then-checkout flow — Shopify's hosted
       checkout does not let a storefront pre-select a payment gateway via URL,
       so the shopper still picks "Kapıda Ödeme" themselves once it loads. */
    var codBtn = e.target.closest("[data-cod-checkout]");
    if (codBtn && !codBtn.disabled) {
      goToCheckout(codBtn);
    }
  });

  function discreetPackagingProperties() {
    var checkbox = root.querySelector("[data-discreet-packaging]");
    if (checkbox && checkbox.checked) {
      return { "Paketleme": window.theme.strings.discreetPackagingTitle || "Gizli Paketleme" };
    }
    return null;
  }

  function goToCheckout(button) {
    var qtyInput = root.querySelector("[data-pdp-qty-input]");
    var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    var originalHTML = button.innerHTML;
    button.disabled = true;
    button.textContent = window.theme.strings.addingShort || button.textContent;
    window.theme.cart
      .add(button.dataset.variantId, qty, discreetPackagingProperties(), { silent: true })
      .then(function () {
        window.location.href = window.themeRoutes.checkoutUrl;
      })
      .catch(function () {
        button.disabled = false;
        button.innerHTML = originalHTML;
      });
  }

  /* Sticky add-to-cart: show once the primary in-buy-box button scrolls out of view */
  var primaryBtn = root.querySelector(".pdp__buy-box [data-add-to-cart]");
  var stickyBar = document.querySelector("[data-sticky-atc]");
  if (primaryBtn && stickyBar && "IntersectionObserver" in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        stickyBar.dataset.visible = String(!entries[0].isIntersecting);
      },
      { rootMargin: "-64px 0px 0px 0px" }
    );
    observer.observe(primaryBtn);
  }
})();
